const endpointHelias = "https://9m4y8iz04h.execute-api.eu-west-3.amazonaws.com/prod"
const deleteInstallationRules = endpointHelias+'/Helias/V0/Rules/deleteInstallationRules'

var initialConfigCommonJS = require("../js/initialConfigCommon.js")
var generalCommonJS = require("../js/generalCommon.js")

exports.borrarRegla = function(params, volverAListadoReglas, ReactGA){
  
  document.getElementById("divErrorGeneral").className=" hidden"

  var lastAuthUser = localStorage.getItem("CognitoIdentityServiceProvider.6m59dtig38s2dgvqdngechft74.LastAuthUser")
  var lastAuthUserIdToken = localStorage.getItem("CognitoIdentityServiceProvider.6m59dtig38s2dgvqdngechft74."+lastAuthUser+".idToken")        

  document.getElementById("loaderGeneralAplicacion").className = "loader"

  //Petición de datos para el paso actual

  var jsonPeticion = ""
  
  jsonPeticion = { "accountID": localStorage.getItem("accountID"), "installationID": localStorage.getItem("installationId"),"idRegla": params.rule.RULE_ID }  

  // Guardo la información  
  var xhttp = new XMLHttpRequest();  
    xhttp.open("DELETE", deleteInstallationRules, true);        
    xhttp.setRequestHeader('Content-Type', "application/json");
    xhttp.setRequestHeader('Authorization', lastAuthUserIdToken);
    var data = JSON.stringify(jsonPeticion);
    xhttp.onreadystatechange = function() {
      if (this.readyState === 4 && this.status === 200) {
        var jsonRespuesta = JSON.parse(this.responseText)

        if(jsonRespuesta.statusCode === "403"){                   
          initialConfigCommonJS.mostrarMensajeInformativo("No tiene permisos para realizar la operación.","negative")              
          document.getElementById("loaderGeneralAplicacion").className = "loader hidden"              
        }
        else{          
          //Si todo ha ido bien
          initialConfigCommonJS.mostrarMensajeInformativo("La regla se ha eliminado correctamente.","positive")              
          document.getElementById("loaderGeneralAplicacion").className = "loader hidden"
          document.getElementById("asideDetalleRegla").className = document.getElementById("asideDetalleRegla").className.replaceAll(" hidden", "") + " hidden"
          document.getElementById("divErrorGeneral").className = document.getElementById("divErrorGeneral").className.replaceAll(" hidden", "") + " hidden"

          generalCommonJS.registrarEventoAnalitica(ReactGA, 'REGLAS', 'REGLA - Eliminada', "", "")

          volverAListadoReglas()        
        }
      }

      if (this.readyState === 4 && this.status !== 200) {                  
        initialConfigCommonJS.mostrarMensajeInformativo("Ha habido algún problema al eliminar la regla, por favor vuelva a intentarlo.","negative")
        document.getElementById("loaderGeneralAplicacion").className = "loader hidden"
      }
    }
    xhttp.send(data);     

  }

exports.filtrarReglasInstalador = function(idCajaBusqueda){

  var cadenaFiltrado = document.getElementById(idCajaBusqueda).value   
  var listadoInstalacionesBuscador = document.getElementById("listadoReglasManuales").children

  var idElementoTemp = ""    

  for (var i = 0; i < listadoInstalacionesBuscador.length; i++) {
    
    idElementoTemp = listadoInstalacionesBuscador[i].id
    
    if( document.getElementById(idElementoTemp).getAttribute("searchdata").includes(cadenaFiltrado.toLowerCase())){
        document.getElementById(idElementoTemp).className = document.getElementById(idElementoTemp).className.replaceAll(" hidden", "")
    }
    else{
      document.getElementById(idElementoTemp).className += " hidden"
    }

  }    

}

exports.filtrarReglasUsuario = function(tipoRegla){

  var cadenaFiltrado = ""
  var listadoInstalacionesBuscador = ""

  if(tipoRegla === "Manuales"){
    cadenaFiltrado = document.getElementById("searchUserRule").value   
    listadoInstalacionesBuscador = document.getElementById("listadoReglasManuales").children
  }
  else{
    cadenaFiltrado = document.getElementById("searchInstallerRule").value   
    listadoInstalacionesBuscador = document.getElementById("listadoReglasAutomaticas").children
  }

  var idElementoTemp = ""    

  for (var i = 0; i < listadoInstalacionesBuscador.length; i++) {
    
    idElementoTemp = listadoInstalacionesBuscador[i].id
    
    if( document.getElementById(idElementoTemp).getAttribute("searchdata").includes(cadenaFiltrado.toLowerCase())){
        document.getElementById(idElementoTemp).className = document.getElementById(idElementoTemp).className.replaceAll(" hidden", "")
    }
    else{
      document.getElementById(idElementoTemp).className += " hidden"
    }

  }    

}

exports.filtrarElementosSeleccionReglas = function(){

  var cadenaFiltrado = document.getElementById("searchElementosReglas").value   

  try{
    var listadoElementosSeleccionables = document.getElementById("listadoElementosSeleccionReglas").querySelectorAll("input[type='checkbox']")   

    var idElementoTemp = ""    
  
    for (var i = 0; i < listadoElementosSeleccionables.length; i++) {
      
      idElementoTemp = listadoElementosSeleccionables[i].id
      
      if( document.getElementById(idElementoTemp).getAttribute("searchtext").toLowerCase().includes(cadenaFiltrado.toLowerCase())){
        document.getElementById("labelDatos"+idElementoTemp).className = document.getElementById("labelDatos"+idElementoTemp).className.replaceAll(" hidden", "")
      }
      else{
        document.getElementById("labelDatos"+idElementoTemp).className = document.getElementById("labelDatos"+idElementoTemp).className.replaceAll(" hidden", "") + " hidden"
      }
  
    }    
  
  }
  catch(error){console.log(error)}
  
}


